<template>
	<b-row align-h="center">
		<b-button
			class="td-btn-outline-blue mr-1"
			v-show="!isEditSelectedData"
			:disabled="!isDimensionNextClicked"
			@click="processingNow(true)"
			>Proses Sekarang <b-icon icon="play-circle" />
		</b-button>
		<b-button
			class="td-btn-blue ml-1"
			v-show="!isEditSelectedData"
			:disabled="!isDimensionNextClicked"
			@click="addDataCart()"
			>Tambahkan Keranjang <b-icon icon="cart4"
		/></b-button>

		<b-button
			class="td-btn-outline-red ml-1"
			v-show="isEditSelectedData"
			:disabled="!hasFinishedLoadEditedSelectedData"
			@click="cancelUpdateDataCart()"
		>
			Batal Update Daftar <b-icon class="ml-1" icon="x-circle"
		/></b-button>
		<b-button
			class="td-btn-blue ml-1"
			v-show="isEditSelectedData"
			:disabled="!isDimensionNextClicked"
			@click="updateDataCart()"
			>Update Daftar <b-icon class="ml-1" icon="check-circle-fill"
		/></b-button>
	</b-row>
</template>

<!-- javascript section-->
<script>
//import js modules section
import utils from "../../../../../utils/TabelDinamisUtils.js";

//local registration for output component
export default {
	name: "BottomMenuSelection",
	data() {
		return {};
	},
	props: [
		"isDimensionNextClicked",
		"addDataCartParent",
		"cancelUpdateDataCartParent",
		"updateDataCartParent",
		"isEditSelectedData",
		"hasFinishedLoadEditedSelectedData",
		"checkDisabledStep2",
		"setIsProcessingNow",
		"setIsStep2",
		"updateTempDataCart"
	],
	created() {},
	destroyed() {},
	mounted: function () {},
	computed: {},
	watch: {},
	methods: {
		addDataCart() {
			this.addDataCartParent();
			this.checkDisabledStep2();
			this.setIsProcessingNow(false);
		},
		cancelUpdateDataCart() {
			this.cancelUpdateDataCartParent();
		},
		updateDataCart() {
			this.updateDataCartParent();
		},
		processingNow() {
			this.setIsStep2(true);
			this.updateTempDataCart();
			this.setIsProcessingNow(true);
			utils.scrollToUpperMost();
		},
	},
	components: {},
};
</script>

<!-- css section-->
<style lang="scss" scoped>
@import "src/assets/scss/_table-dinamis";
</style>

<!-- author: m.hanif.fahyuananto-->
<!-- version 3.0.0 -->
<!-- created on 24-06-2022 -->
